import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export const Breadcrumbs = ({
  customBreadcrumbs = null,
  siteName = "Red Arauca",
}) => {
  const location = useLocation();

  // Generar breadcrumbs automáticamente si no se proporcionan
  const generateBreadcrumbs = () => {
    if (customBreadcrumbs) return customBreadcrumbs;

    const pathnames = location.pathname.split("/").filter((x) => x);
    const breadcrumbs = [{ name: "Inicio", url: "/" }];

    let currentPath = "";
    pathnames.forEach((name, index) => {
      currentPath += `/${name}`;

      // Transformar nombres de rutas
      let displayName = name;
      if (name === "post") {
        displayName = "Noticia";
      } else if (name === "categoria") {
        displayName = "Categoría";
      } else if (name === "noticias") {
        displayName = "Noticias";
      } else {
        displayName =
          name.charAt(0).toUpperCase() + name.slice(1).replace(/-/g, " ");
      }

      breadcrumbs.push({
        name: displayName,
        url: currentPath,
        isLast: index === pathnames.length - 1,
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  // Generar Schema.org para breadcrumbs
  const generateBreadcrumbSchema = () => {
    const itemListElements = breadcrumbs.map((crumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: crumb.name,
      item: `${window.location.origin}${crumb.url}`,
    }));

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: itemListElements,
    };
  };

  if (breadcrumbs.length <= 1) return null;

  return (
    <>
      {/* Schema.org para breadcrumbs */}
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(generateBreadcrumbSchema())}
        </script>
      </Helmet>

      <nav className="breadcrumbs" aria-label="Navegación breadcrumb">
        <style jsx>{`
          .breadcrumbs {
            padding: 0;
          }

          .breadcrumb-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0;
          }

          .breadcrumb-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            margin: 0;
            padding: 0;
            list-style: none;
            font-size: 0.9rem;
          }

          .breadcrumb-item {
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .breadcrumb-link {
            color: #d4d9e2ff;
            text-decoration: none;
            transition: color 0.3s ease;
          }

          .breadcrumb-link:hover {
            color: #dce0e9ff;
            text-decoration: underline;
          }

          .breadcrumb-current {
            color: #d0e0ffff;
            font-weight: 500;
          }

          .breadcrumb-separator {
            color: #9ca3af;
            font-size: 0.8rem;
            user-select: none;
          }

          @media (max-width: 640px) {
            .breadcrumb-list {
              font-size: 0.8rem;
            }
          }
        `}</style>

        <div className="breadcrumb-container">
          <ol className="breadcrumb-list">
            {breadcrumbs.map((crumb, index) => (
              <li key={crumb.url} className="breadcrumb-item">
                {crumb.isLast ? (
                  <span className="breadcrumb-current" aria-current="page">
                    {crumb.name}
                  </span>
                ) : (
                  <Link to={crumb.url} className="breadcrumb-link">
                    {crumb.name}
                  </Link>
                )}

                {index < breadcrumbs.length - 1 && (
                  <span className="breadcrumb-separator" aria-hidden="true">
                    /
                  </span>
                )}
              </li>
            ))}
          </ol>
        </div>
      </nav>
    </>
  );
};
